module.exports = __webpack_public_path__ + "img/title.b3b19481.png";